import axios from '@/libs/api.request'
import qs from 'qs'

const baseUrl = '/order/customer-service'

export const searchCustomerServiceOrders = (params) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/orders/search`,
    params,
    // 商品类型支持多选，使用重复参数确保Spring能够稳定绑定List<Integer>。
    paramsSerializer: (query) => qs.stringify(query, { arrayFormat: 'repeat' })
  })
}

export const getCustomerServiceOrderPreview = (orderId, params) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/orders/${orderId}/preview`,
    params
  })
}

export const previewCustomerServiceSupplementEquity = (data) => {
  return axios.request({
    method: 'post',
    url: `${baseUrl}/supplement/equity-preview`,
    data
  })
}

export const getCustomerServiceSubscriptionStatus = (orderId) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/orders/${orderId}/subscription-status`
  })
}

export const queryPlatformOrder = (params) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/platform/orders/query`,
    params
  })
}

export const queryPlatformSubscription = (params) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/platform/subscriptions/query`,
    params
  })
}

export const supplementCustomerServiceOrder = (data) => {
  return axios.request({
    method: 'post',
    url: `${baseUrl}/supplement`,
    data
  })
}

export const refundCustomerServiceOrder = (data) => {
  return axios.request({
    method: 'post',
    url: `${baseUrl}/refund`,
    data
  })
}

export const cancelCustomerServiceSubscription = (data) => {
  return axios.request({
    method: 'post',
    url: `${baseUrl}/cancel-subscription`,
    data
  })
}

export const getAfterSalesOverview = () => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/after-sales/overview`
  })
}

export const getAfterSalesList = (params) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/after-sales`,
    params
  })
}

export const getAfterSalesDetail = (orderId) => {
  return axios.request({
    method: 'get',
    url: `${baseUrl}/after-sales/${orderId}`
  })
}
